import { Box, Button, Stack } from '@mui/material';

import useQuestionnaireFooterNavigation from '../hooks/useQuestionnaireFooterNavigation';
import { QUESTIONNAIRE_FOOTER_BUTTON_SX } from '../styles';

import type { QuestionnaireFooterProps } from '../types';

export default function QuestionnaireFooter({
  tabConfigs,
  basePath,
  terminalTabId,
  terminalAction,
}: QuestionnaireFooterProps) {
  const { handleNext, handlePrevious, isFirstPage, isTerminalPage } =
    useQuestionnaireFooterNavigation(tabConfigs, basePath, terminalTabId);

  return (
    <Box component="footer">
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Button
          disabled={isFirstPage}
          sx={{
            ...QUESTIONNAIRE_FOOTER_BUTTON_SX,
            visibility: isFirstPage ? 'hidden' : 'visible',
          }}
          onClick={handlePrevious}
          type="button"
          variant="contained"
        >
          Previous
        </Button>
        {isTerminalPage ? (
          terminalAction
        ) : (
          <Button
            sx={QUESTIONNAIRE_FOOTER_BUTTON_SX}
            onClick={handleNext}
            type="button"
            variant="contained"
          >
            Next
          </Button>
        )}
      </Stack>
    </Box>
  );
}
